export default __webpack_public_path__ + "beb1d3d72c15f8bf1078a89a541765d3.svg";